module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_4750_Inactive@1x-f1b04df4aaad3ed33881776d95bacbb6.png";